<script setup lang="ts">
import { UiButton } from "@shopexperts/shared";
import { quoteCopy } from "@/v2Projects/utils/quoteCopy";

defineProps<{
  isPaidQuote: boolean;
  invoiceUrl?: string | null;
  showAcceptQuote: boolean;
  showRejectQuote: boolean;
  acceptLabel?: string;
}>();

defineEmits<{
  reject: [];
  accept: [];
  openInvoice: [];
}>();
</script>

<template>
  <section
    v-if="isPaidQuote || showAcceptQuote || showRejectQuote"
    class="flex flex-wrap items-center justify-end gap-3
      max-sm:flex-col max-sm:flex-nowrap max-sm:items-stretch max-sm:gap-2"
  >
    <UiButton
      v-if="isPaidQuote"
      variant="primary"
      :label="quoteCopy.proposalDetails.openInvoiceAction"
      :disabled="!invoiceUrl"
      class="max-sm:w-full"
      @click="$emit('openInvoice')"
    />
    <template v-else>
      <UiButton
        v-if="showRejectQuote"
        variant="outline"
        :label="quoteCopy.proposalDetails.rejectAction"
        class="max-sm:w-full"
        @click="$emit('reject')"
      />
      <UiButton
        v-if="showAcceptQuote"
        variant="primary"
        :label="acceptLabel ?? quoteCopy.proposalDetails.acceptAction"
        class="max-sm:w-full"
        @click="$emit('accept')"
      />
    </template>
  </section>
</template>
